import React from "react";
import Module from "../template/Module";

export default () => <Module />;
